module.exports = __webpack_public_path__ + "img/3.0448b171.png";